import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'veririkfasiAbsen'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterEmployeeStatus = 'Kepegawaian/List/employeeStatus/'
export const masterWorkUnit = 'Master/List/workUnit/'

export const verList = 'Kepegawaian/VerificationPresensi/list/'
export const verListTunkin = 'Kepegawaian/VerificationPresensi/listTunkin/'
export const verListHonorarium = 'Kepegawaian/VerificationPresensi/listHonorarium/'
export const verListUangMakan = 'Kepegawaian/VerificationPresensi/listUangMakan/'
export const verListPltPlh = 'Kepegawaian/VerificationPresensi/listPltPlh/'
export const verCheck = 'Kepegawaian/VerificationPresensi/check/'
export const verCheckGenerate = 'Kepegawaian/VerificationPresensi/checkGenerate/'
export const verSetGenerate = 'Kepegawaian/VerificationPresensi/setGenerate/'
export const verVerification = 'Kepegawaian/VerificationPresensi/verification/'
export const exportExcelTunkin = 'Kepegawaian/VerificationPresensi/exportExcelTunkin/'
export const exportExcelTunkinTxt = 'Kepegawaian/VerificationPresensi/exportExcelTunkinTxt/'
export const exportExcelHonorarium = 'Kepegawaian/VerificationPresensi/exportExcelHonorarium/'
export const exportExcelHonorariumTxt = 'Kepegawaian/VerificationPresensi/exportExcelHonorariumTxt/'
export const exportExcelUangMakan = 'Kepegawaian/VerificationPresensi/exportExcelUangMakan/'
export const exportExcelUangMakanTxt = 'Kepegawaian/VerificationPresensi/exportExcelUangMakanTxt/'
export const exportExcelPltPlh = 'Kepegawaian/VerificationPresensi/exportExcelPltPlh/'
export const exportExcelPltPlhTxt = 'Kepegawaian/VerificationPresensi/exportExcelPltPlhTxt/'
export const checkGenerateStatus = 'Kepegawaian/VerificationPresensi/checkGenerateStatus/'
export const syncPresensi = 'Kepegawaian/VerificationPresensi/syncPresensi/'
export const openVerification = 'Kepegawaian/VerificationPresensi/openverification/'
export const fetchExportMatching = 'Kepegawaian/VerificationPresensi/exportMatching/'
export const fetchVerifikasiMatching = 'Kepegawaian/VerificationPresensi/verificationMatching/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}